import {FlowCloudController} from '@mintdata-wsp/common/controllers/flow/FlowCloudController';
import {SocketConfig} from '@mintdata-wsp/common/controllers/network/socket/SocketConfig';
import {FlowSimulation} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';

export class WspFlowCloudController extends FlowCloudController
{
    public onDesignOpened(designId:number)
    {
        const apiHostname = ConfigUtil.apiHostname();
        const apiSecure = ConfigUtil.apiSecure();
        const apiPort = apiSecure ? 443 : 80;

        const functionsWsUrl = `/api/ws/functions?designId=${designId}`;

        const socketConfig = new SocketConfig(
            apiSecure,
            apiHostname,
            apiPort,
            functionsWsUrl
        );

        this.setSocketConfig(socketConfig);
    }

    protected handleDataFrame(simulation:FlowSimulation, frame:IFrame)
    {
        const {flowSimulationMessages, visualData} = controllers.ui;

        if( simulation.isForFlowEditor )
        {
            visualData.onSouthboundFrame(frame);
            flowSimulationMessages.logMessage(simulation.id, `New data: ${frame.toString()}`);
        }

        super.handleDataFrame(simulation, frame);
    }
}
